import useRouter from '../../../hooks/useRouter'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { routes } from '../../../router'
import RadioGroup from '../../../components/RadioGroup/RadioGroup'
import {
  TABS_OPTIONS,
  TABS_OPTIONS_KEY,
  TABS_OPTIONS_VENDORS_CONTRACT_ADMIN
} from './constants'
import { MY_COMMUNITY_KEYS } from '../constants'
import { VendorInfo } from '../../VendorInfo'
import { useDispatch, useSelector } from 'react-redux'
import { getUser } from '../../../redux/store/user/getters'
import { ROLES } from '../../Permission'
import { General } from './General/General'
import { VendorUsers } from '../Vendors/VendorUsers/VendorUsers'
import { BankingSetup } from './BankingSetup/BankingSetup'
import { BankAccountContainer } from 'features/BankAccount/BankAccountContainer'
import { TBusinessDetails } from './BankingSetup/types'
import { businessDetailsInitialValues } from './BankingSetup/constants'
import { setLoading } from '../../../redux/store/common/slice'
import { getBusinessDetailsVendorOrganization } from './api'
import { getVendorInfo } from '../../../redux/store/vendorInfo/getters'
import { SETTINGS_STATUSES } from '../../../pages/Settings/constants'

export const MyOrganizationVendor = () => {
  const dispatch = useDispatch()

  const user = useSelector(getUser)
  const vendorInfo = useSelector(getVendorInfo)

  const { query, navigate, push } = useRouter()
  const [activeSubTab, setActiveSubTab] = useState(TABS_OPTIONS[0].value)
  const [businessDetails, setBusinessDetails] = useState<TBusinessDetails>(
    businessDetailsInitialValues
  )
  useEffect(() => {
    if (Object.values(TABS_OPTIONS_KEY).includes(query?.type)) {
      setActiveSubTab(query.type)
    } else if (Object.values(TABS_OPTIONS_KEY).includes(query?.tab)) {
      setActiveSubTab(query.tab)
    } else {
      setActiveSubTab(TABS_OPTIONS[0].value)
    }
  }, [query])

  const isBankAccountsDisabled = useMemo(() => {
    return businessDetails?.verification_status !== SETTINGS_STATUSES.VERIFIED
  }, [businessDetails?.verification_status])

  const tabs = useMemo(() => {
    const isVendorAdmin = user.role === ROLES.VENDOR_CONTRACT_ADMIN

    if (!isVendorAdmin) {
      return TABS_OPTIONS
    }

    return TABS_OPTIONS_VENDORS_CONTRACT_ADMIN.map((tab) => {
      if (tab.value !== 'bank_accounts') return tab

      return {
        ...tab,
        disabled: isBankAccountsDisabled
      }
    })
  }, [user.role, isBankAccountsDisabled])

  const handleTabs = (e) => {
    setActiveSubTab(e)
    if (user.vendor) {
      navigate(
        `${routes.myCommunity}/${MY_COMMUNITY_KEYS.my_organization}/${e}`
      )
    } else {
      push(e)
    }
  }

  const getBusinessDetails = useCallback(async () => {
    if (!vendorInfo?.moov_business_account) return
    try {
      dispatch(setLoading(true))
      const res = await getBusinessDetailsVendorOrganization(
        vendorInfo.moov_business_account
      )
      if (!!res?.data) setBusinessDetails(res?.data)
    } catch (e) {
      console.error(e)
    } finally {
      dispatch(setLoading(false))
    }
  }, [dispatch, vendorInfo])

  useEffect(() => {
    getBusinessDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorInfo])

  return (
    <div className="my-organisation-container">
      <RadioGroup.Buttons
        options={tabs}
        defaultValue={activeSubTab}
        onChange={handleTabs}
        className="mt-0 mb-24"
      />
      {user.role === ROLES.VENDOR_CONTRACT_ADMIN &&
        activeSubTab === TABS_OPTIONS_KEY.general && (
          <VendorInfo businessDetails={businessDetails} />
        )}
      {user.role !== ROLES.VENDOR_CONTRACT_ADMIN &&
        activeSubTab === TABS_OPTIONS_KEY.general && <General />}
      {activeSubTab === TABS_OPTIONS_KEY.vendor_users && <VendorUsers />}
      {activeSubTab === TABS_OPTIONS_KEY.banking_setup && (
        <BankingSetup
          businessDetails={businessDetails}
          getBusinessDetails={getBusinessDetails}
        />
      )}
      {activeSubTab === TABS_OPTIONS_KEY.bank_accounts &&
        !isBankAccountsDisabled && (
          <BankAccountContainer
            businessDetails={businessDetails}
            getBusinessDetails={getBusinessDetails}
          />
        )}
    </div>
  )
}
